import React from 'react';
import Modal from './Modal';
import './TimeoutModal.css';

interface TimeoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
  operationName?: string;
}

const TimeoutModal: React.FC<TimeoutModalProps> = ({
  isOpen,
  onClose,
  onRetry,
  operationName = 'la operación'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Tiempo de espera agotado"
      onConfirm={onRetry || onClose}
      confirmText={onRetry ? "Reintentar" : "Entendido"}
      cancelText={onRetry ? "Cancelar" : ""}
    >
      <div className="timeout-modal-content">
        <p>
          {operationName.charAt(0).toUpperCase() + operationName.slice(1)} está tardando más de lo esperado.
        </p>
        <p className="timeout-modal-hint">
          Esto puede deberse a una conexión lenta o a que el servidor está procesando una gran cantidad de datos.
        </p>
        {onRetry && (
          <p className="timeout-modal-suggestion">
            Puedes intentar nuevamente o verificar tu conexión a internet.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default TimeoutModal;
